<template>
  <v-container>
    <v-layout row>
      <v-flex>
        <v-card-text>
          <v-container>
            <h2>Becoming Order</h2>
            <v-btn to="/iabf/admin/costume-orders">
              &lt; Back to Costume Orders
            </v-btn>

            <h3 class="mt-5">Pick-up at IABF</h3>

            <h4 class="mt-3">Crop Top Count by Size</h4>
            <vue-good-table
              :columns="sizeColumns"
              :rows="[cropTopPickupCounts]"
            >
            </vue-good-table>

            <h4 class="mt-3">Skirt (Buy &amp; Borrow) Count by Size</h4>
            <vue-good-table
              :columns="sizeColumns"
              :rows="[skirtPickupCounts]"
            >
            </vue-good-table>

            <h3 class="mt-5">
              Buy &amp; Ship
              <span class="ship-progress">{{ shippedCount }} of {{ shipRows.length }} shipped</span>
            </h3>
            <vue-good-table
              :columns="shipColumns"
              :rows="shipRows"
              :line-numbers="true"
            >
              <div slot="emptystate">
                No ship orders found!
              </div>
              <template slot="table-row" slot-scope="props">
                <span v-if="props.column.field === 'shipped'">
                  <label class="ship-toggle">
                    <input
                      type="checkbox"
                      :checked="!!props.row.shippedAt"
                      :disabled="savingId === props.row.dancerId"
                      @change="onToggleShipped(props.row, $event.target.checked)"
                    />
                    <span v-if="props.row.shippedAt" class="ship-date">{{ formatShippedAt(props.row.shippedAt) }}</span>
                  </label>
                </span>
                <span v-else>{{ props.formattedRow[props.column.field] }}</span>
              </template>
            </vue-good-table>
          </v-container>
        </v-card-text>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<style>
  h2 {
    font-family: Quattrocento;
    font-weight: 400;
    font-size: 39px;
    letter-spacing: -.02em;
    line-height: 1em;
  }

  h3 {
    font-family: ltc-bodoni-175;
    font-size: 22px;
  }

  h4 {
    font-family: ltc-bodoni-175;
    font-size: 18px;
  }

  .vgt-table, v-btn {
    font-family: Fanwood Text;
  }

  .vgt-table thead {
    font-size: 1.2em !important;
  }

  .ship-progress {
    font-family: 'Fanwood Text', Georgia, serif;
    font-size: 14px;
    font-style: italic;
    color: #267E7D;
    margin-left: 12px;
  }

  .ship-toggle {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    cursor: pointer;
  }

  .ship-date {
    font-family: 'Fanwood Text', Georgia, serif;
    font-size: 12px;
    color: #2e7d32;
    font-weight: 700;
  }
</style>

<script>
import iabfAdminMixin from '@/utils/iabf-admin-mixin'


import 'vue-good-table/dist/vue-good-table.css'
import { VueGoodTable } from 'vue-good-table'
import { db } from '@/firebase'
import firebase from 'firebase/app'

export default {
  mixins: [iabfAdminMixin],
    components: {
      VueGoodTable
    },
    data () {
      return {
        sizeColumns: [
          { label: 'T', field: 'T' },
          { label: 'SA', field: 'SA' },
          { label: 'MA', field: 'MA' },
          { label: 'LA', field: 'LA' },
          { label: 'XLA', field: 'XLA' }
        ],
        shipColumns: [
          { label: 'Shipped', field: 'shipped' },
          { label: 'Dancer', field: 'dancer' },
          { label: 'Crop Top Size', field: 'cropTopSize' },
          { label: 'Skirt Size', field: 'skirtSize' },
          { label: 'Shipping Address', field: 'shippingAddress' }
        ],
        savingId: null,
        cropTopPickupCounts: { T: 0, SA: 0, MA: 0, LA: 0, XLA: 0 },
        skirtPickupCounts: { T: 0, SA: 0, MA: 0, LA: 0, XLA: 0 },
        shipRows: []
      }
    },
    created () {
      this.$store.dispatch('loadIABFDancers').then(() => {
        this.$store.getters.loadedIABFDancers.forEach((dancer) => {
          this.processDancer(dancer)
        })
      })
    },
    computed: {
      shippedCount () {
        return this.shipRows.filter(r => !!r.shippedAt).length
      }
    },
    methods: {
      dancerName (dancer) {
        return dancer.firstName + ' ' + (dancer.lastName ? dancer.lastName.charAt(0) + '.' : '')
      },
      incrementSize (countsObj, size) {
        if (size && countsObj[size] !== undefined) {
          countsObj[size]++
        }
      },
      formatShippedAt (ts) {
        if (!ts) return ''
        const d = ts.toDate ? ts.toDate() : (ts instanceof Date ? ts : new Date(ts))
        if (isNaN(d.getTime())) return ''
        return d.toLocaleDateString(undefined, { month: 'short', day: 'numeric' })
      },
      async onToggleShipped (row, checked) {
        this.savingId = row.dancerId
        try {
          if (checked) {
            const ts = firebase.firestore.Timestamp.now()
            await db.collection(this.IABF.dancers).doc(row.dancerId).update({
              'becoming.shippedAt': ts
            })
            this.$set(row, 'shippedAt', ts)
          } else {
            await db.collection(this.IABF.dancers).doc(row.dancerId).update({
              'becoming.shippedAt': firebase.firestore.FieldValue.delete()
            })
            this.$set(row, 'shippedAt', null)
          }
        } catch (e) {
          // eslint-disable-next-line no-alert
          window.alert('Failed to update shipped status: ' + (e.message || e))
        }
        this.savingId = null
      },
      processDancer (dancer) {
        const bec = dancer.becoming || {}
        if (!bec.participating) return

        if (bec.topChoice === 'crop') {
          // Pick-up at IABF: crop top
          this.incrementSize(this.cropTopPickupCounts, bec.cropTopSize)
        }

        // Count all skirts (buy or borrow) except ship orders
        if (bec.topChoice !== 'crop_ship' && (bec.skirtChoice === 'buy' || bec.skirtChoice === 'borrow')) {
          this.incrementSize(this.skirtPickupCounts, bec.skirtSize)
        }

        if (bec.topChoice === 'crop_ship') {
          // Buy & Ship: crop top + skirt
          const addr = [
            bec.shippingName,
            bec.shippingAddress1,
            bec.shippingAddress2,
            bec.shippingCity,
            bec.shippingState,
            bec.shippingZip
          ].filter(s => s).join(', ')

          this.shipRows.push({
            dancerId: dancer.id,
            dancer: this.dancerName(dancer),
            cropTopSize: bec.cropTopSize || '',
            skirtSize: bec.skirtSize || '',
            shippingAddress: addr,
            shippedAt: bec.shippedAt || null
          })
        }
      }
    }
  }
</script>
